export default "/images/vendor/flag-icons/flags/4x3/ba.svg?ae994e09174207b350e9e8fb4ad86f1f";